/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface SortirArticle$Params {
  /**
   * id magasin
   */
  'id-magasin': string;

  /**
   * code article
   */
  'code-article': string;

  /**
   * dk code technicien
   */
  'dk-code-ressource': string;

  /**
   * nombre d'article sortie
   */
  quantity: number;
}

export function sortirArticle(
  http: HttpClient,
  rootUrl: string,
  params: SortirArticle$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, sortirArticle.PATH, 'post');
  if (params) {
    rb.path('id-magasin', params['id-magasin'], {});
    rb.path('code-article', params['code-article'], {});
    rb.query('dk-code-ressource', params['dk-code-ressource'], {});
    rb.query('quantity', params.quantity, {});
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    })
  );
}

sortirArticle.PATH = '/v1/magasins/{id-magasin}/articles/{code-article}/sortie';
